import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import Archive from "../views/Archive.vue";
import Register from "../views/Register.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import NewTale from "../views/NewTale.vue"
import Search from "../views/Search.vue"
import Settings from "../views/Settings.vue"
import PasswordReset from "../views/PasswordReset.vue"
import store from "../store";
import { getUser, logout } from "../service/user";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/password-reset",
      name: "password-reset",
      component: PasswordReset,
      meta: { requiresAuth: false }
    },


    {
      path: "/",
      name: "dashboard",
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: "/archive",
      name: "archive",
      component: Archive,
      meta: { requiresAuth: true }
    },
    {
      path: "/new",
      name: "new",
      component: NewTale,
      meta: { requiresAuth: true }
    },
    {
      path: "/tale/:id",
      name: "tale",
      component: NewTale,
      meta: { requiresAuth: true }
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: { requiresAuth: true }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: { requiresAuth: true }
    },
    {
      path: "/register",
      component: Register,
      meta: { guest: true }
    },
    {
      path: "/login",
      component: Login,
      meta: { guest: true }
    },
    {
      path: "/logout",
      component: Logout,
      meta: { requiresAuth: true }
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("user") == null && store.state.user == '') {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      getUser().then((res)=> {
        store.state.user = res.data.data;
      }).catch(function () {
        logout();
        next({
          path: "/login",
        });
      });

      const user = JSON.parse(localStorage.getItem("user"));
      if (to.matched.some((record) => record.meta.is_admin)) {
        if (user.role == 1) {
          next();
        } else {
          next({ name: "Dashboard" });
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem("user") == null || store.state.user == '') {
      next();
    } else {
      next({ name: "Dashboard" });
    }
  } else {
    next();
  }
});

export default router;
